<template>
  <div class="dialog">
    <div class="dialog-header" :style="{backgroundColor: event.color}">
      <div class="header-top">
        <v-touch @tap="close" class="no-desktop">
          <div class="font-large close-tap"><span class="icon-cross2 pointer"></span></div>
        </v-touch>
        <div class="font-large no-mobile close-tap" @click="close"><span class="icon-cross2 pointer"></span></div>
      </div>
      <div class="header-body">
        <div class="d-show-event__header__do-warning__container">
          <div class="d-show-event__header__do-warning do-warning do-warning--canceled" v-if="event && event.canceled">
            <span class="icon-notification22"></span>
            {{ i18n.canceled }}
          </div>
          <div class="d-show-event__header__do-warning do-warning" v-if="event && event.away">
            {{ i18n.out_of_school }}</div>
        </div>
        <h1>{{ event.index }}</h1>
        <section class="dialog-body">
          <div class="dialog-icon"></div>
          <div class="dialog-text">
            <h1>{{ event.title }}</h1>
          </div>
        </section>
        <section class="dialog-body">
          <div class="dialog-icon">
          </div>
          <div class="dialog-text">
            <p>{{ dayAndDate }}</p>
          </div>
        </section>
        <section class="dialog-body">
          <div class="dialog-icon">
            <span class="icon-clock"></span>
          </div>
          <div class="dialog-text">
            <b>{{ $filters.LT(event.start) }} - {{ $filters.LT(event.end) }}</b>
            <span>(
              <span
                v-if="eventHours >= 1">{{ eventHours }} {{
                  eventHours > 1 ? $t('calendars.subject_hours.timer') : $t('repitition.hour')
                }} </span>
              <span v-if="eventMinutes >= 1">{{ eventMinutes + ' min' }}</span>
            )</span>
          </div>
        </section>
      </div>
    </div>
    <div class="dialog__dialog-body">
      <ul>
        <li v-if="event.group" class="pad-15-0 border-bottom">
          <div class="dialog-icon" style="margin-top: -1px">
            <span class="icon-calendar4"></span>
          </div>
          <div class="dialog-text">
            <b>{{ event.group }}</b>
          </div>
        </li>
        <li v-if="event.teacher" class="pad-15-0 border-bottom">
          <div class="dialog-icon">
            <span class="icon-user"></span>
          </div>
          <div class="dialog-text">
            <b>{{ event.teacher }}</b>
          </div>
        </li>
        <li v-if="event.room" class="pad-15-0 border-bottom">
          <div class="dialog-icon">
            <span class="icon-location"></span>
          </div>
          <div class="dialog-text">
            <b>{{ event.room }}</b>
          </div>
        </li>
        <li v-if="checkLengthWithoutHTML(event.learning_goal)" class="pad-15-0 border-bottom">
          <div class="dialog-text marg-10-bottom">
            <b :style="{color: event.color}">{{ $t('calendars.week_plan.learning_goal') }}</b>
          </div>
          <div class="dialog-text__content" v-html="event.learning_goal"></div>
        </li>
        <li v-if="checkLengthWithoutHTML(event.description)" class="pad-15-0 border-bottom">
          <div class="dialog-text marg-10-bottom">
            <b :style="{color: event.color}">{{ $t('calendars.week_plan.content') }} </b>
          </div>
          <div class="dialog-text__content" v-html="event.description"></div>
        </li>
        <li v-if="checkLengthWithoutHTML(event.notes_for_students)" class="pad-15-0 border-bottom">
          <div class="dialog-text marg-10-bottom">
            <b :style="{color: event.color}">{{ $t('calendars.week_plan.pupil_preparation') }}</b>
          </div>
          <div class="dialog-text__content" v-html="event.notes_for_students"></div>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import moment from 'moment'

export default {
  props: {
    event: {
      type: Object
    },
    locale: {
      default: window.USER && window.USER.locale ? window.USER.locale : 'en'
    },
    i18n: {}
  },
  computed: {
    eventMinutes () {
      let hours = Math.floor(this.event.duration / 60)
      let minutes = (this.event.duration - hours * 60)
      return minutes
    },
    eventHours () {
      return Math.floor(this.event.duration / 60)
    },
    dayAndDate () {
      // NN hack
      if (this.locale === 'nn' || this.locale === 'nb') {
        return moment(this.event.start).format('dddd DD. MMMM YYYY')
      }
      try {
        return moment(this.event.start)._d.toLocaleDateString(this.locale, {
          weekday: 'long',
          month: 'long',
          day: '2-digit',
          year: 'numeric'
        })
      } catch (e) {
        return moment(this.event.start).format('LL')
      }
    }
  },
  methods: {
    checkLengthWithoutHTML (text) {
      return text.replace(/<(?:.|\n)*?>/gm, '')
    },
    close () {
      this.$emit('close')
    }
  }
}

</script>

<style scoped>

@import "../../assets/css/variables.css";

.dialog {
  position: fixed;
  top: 0;
  right: 0;
  height: 100vh;
  width: 100%;
  z-index: 10000;
  font-size: 13px;
  background: white;
  overflow-y: hidden;
  color: var(--dark-blue);
}

@media only screen and (min-width: 768px) {
  .dialog {
    width: 40%;
    box-shadow: 0 10px 20px rgba(0, 0, 0, 0.19), 0 6px 6px rgba(0, 0, 0, 0.23);
  }
}

.dialog-header {
  color: white;
  padding: 0;
  min-height: 160px;
}

.close-tap {
  padding: 20px 20px 0;
}

.header-body {
  padding: 0 0 20px;
}

.dialog-body {
  padding: 0 20px;
}

.dialog__dialog-body {
  padding: 0 20px;
  height: calc(100% - 160px);
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
}

.pad-15-0 {
  padding: 15px 0;
}

.header-body > .dialog-body > .dialog-icon {
  color: #ffffff;
}

.dialog-icon {
  color: #CCC;
}

.dialog-icon {
  float: left;
  width: 35px;
  min-height: 1px;
  max-height: 10px;
}

.dialog-text {
  min-height: 1px;
  margin-top: -1px;
}

.dialog-text ul, .dialog-text ol {
  margin-left: 20px;
  list-style-type: disc;
}

.dialog-text ol {
  list-style-type: decimal;
}

.border-bottom {
  border-bottom: 1px solid var(--bg-grey)
}

.pointer {
  cursor: pointer;
}

.d-show-event__header__do-warning__container {
  position: relative;
  left: 55px;
  display: inline-flex;
  gap: 0.5rem;
}

.d-show-event__header__do-warning.do-warning {
  font-weight: bold;
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  padding: 3px 8px;
}

.do-warning.do-warning--canceled {
  background-color: #fddddd;
  color: #c20006;
  border-color: #fddddd;
}

</style>



// WEBPACK FOOTER //
// ShowEvent.vue?03c00140